import { FieldError } from 'react-hook-form';
import { CustomFormControl } from '../CustomFormControl';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_MAPPER } from '../../../../services';
import { UIDateInput } from './UIDateInput';

export interface ICustomDateInput {
  label?: string;
  value?: Date | string;
  error?: FieldError | undefined;
  onChange?: (x: any) => void;
  isReadOnly?: boolean;
  isRequired?: boolean;
}

export const CustomDateInput = (props: ICustomDateInput) => {
  const { i18n } = useTranslation();
  const { label, value, onChange, error, isReadOnly, isRequired, ...restProps } = props;

  return (
    <CustomFormControl
      label={label}
      error={error}
      value={value}
      sx={{ zIndex: 1 }}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
    >
      <DatePicker
        dateFormat='dd/MM/yyyy'
        selected={value ? new Date(value) : null}
        adjustDateOnChange
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          }
        }}
        locale={LANGUAGE_MAPPER[i18n?.language]}
        maxDate={new Date()}
        showYearDropdown
        yearDropdownItemNumber={100}
        scrollableYearDropdown
        onKeyDown={(e: any) => e.preventDefault()}
        customInput={<UIDateInput {...restProps} />}
        fixedHeight
        readOnly={isReadOnly}
      />
    </CustomFormControl>
  );
};
